// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cp-2";
export var aiChatCartContainerExit = "_cp-4";
export var aiChatContainerLarge = "_cp-0";
export var aiChatContainerSmall = "_cp-1";
export var aiChatIcon = "_cp-6";
export var slideInFromRight = "_cp-3";
export var slideOutToRight = "_cp-5";